import { useState, useContext } from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import PersonIcon from '@mui/icons-material/Person';
import LanguageSelect from "../../shared-theme/components/LanguageSelect";

import { AccountContext } from "@context/AccountProvider";
import MenuContent from './MenuContent';
import ImageAvatarView from "@component/ImageAvatarView"

import SidePanel from "@component/SidePanel";
import MyAccountForm from '@component/MyAccountForm';

import { useTranslation } from "react-i18next";
import { useLogoutMutation } from '@mutation/authMutation';

function SideMenuMobile({ open, toggleDrawer }) {

  const { t } = useTranslation("main");
  const { account } = useContext(AccountContext);
  const logoutMutation = useLogoutMutation();
  const [detailPanelOpen, setDetailPanelOpen] = useState(false);

  const handleLogout = () => {
    logoutMutation.mutate();
  };
  
  const handleAccountClick = () => {
    setDetailPanelOpen(true);
    toggleDrawer(false);
  }

  const handleDetailPanelClose = () => {
    setDetailPanelOpen(false);
    toggleDrawer(true);
  };

  return (
    <>
    {/* Side Panel for Viewing/Updating my Account */}
      <SidePanel width={438} maxWidth={438} minWidth={360} open={detailPanelOpen} onClose={handleDetailPanelClose} title={t('account:myAccountDetails')}>
        <MyAccountForm />
      </SidePanel>

      <Drawer
        anchor="right"
        open={open}
        onClose={() => toggleDrawer(false)}
        sx={{
          [`& .${drawerClasses.paper}`]: {
            backgroundImage: 'none',
            backgroundColor: 'background.paper',
          },
        }}
      >
        <Stack
          sx={{
            maxWidth: '70dvw',
            height: '100%',
          }}
        >
          <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1, alignItems: "center" }}>
            <Stack
              direction="row"
              sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
            >
              <ImageAvatarView fileUuid={account.file_image_uuid} avatarSx={{ width: 40, height: 40}}/>
              <Typography component="p" variant="h6">
              { account ? account.first_name + " " + account.last_name : "" }
              </Typography>
            </Stack>
              <LanguageSelect/>
          </Stack>
          <Divider />
          <Stack sx={{ flexGrow: 1 }}>
            <MenuContent />
            <Divider />
          </Stack>
          <Stack sx={{ p: 2, gap: 1 }}>
            <Button variant="outlined"
                    fullWidth
                    startIcon={<PersonIcon />}
                    onClick={handleAccountClick}>
              {t("myAccount")}
            </Button>

            <Button variant="outlined"
                    fullWidth
                    startIcon={<LogoutRoundedIcon />}
                    onClick={handleLogout}>
              {t("logout")}
            </Button>
          </Stack>
        </Stack>
      </Drawer>
      
    </>
  );
}

export default SideMenuMobile;
